import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const baseUrl = createApiUrl('/api/search/')
const isbnUrl = createApiUrl('/api/search/isbn/')
const doiUrl = createApiUrl('/api/search/doi/')

const retrieve = async (query='') => {
    // Use high limit for admin operations to get all resources
    const limitParam = query ? `&limit=1000` : 'limit=1000'
    const fullQuery = query ? `${query}${limitParam}` : limitParam
    const res = await axios.get(`${baseUrl}?${fullQuery}`, tokenService.getAuthHeader())
    return res.data.results || res.data
}

const retrieveBook = async (isbn) => {
    const res = await axios.get(`${isbnUrl}?isbn=${isbn}`, tokenService.getAuthHeader())
    return res.data.items[0]
}

const retrievePaper = async (doi) => {
    const res = await axios.get(`${doiUrl}?doi=${doi}`, tokenService.getAuthHeader())
    return res.data
}

const resourcesService = { retrieve, retrieveBook, retrievePaper }

export default resourcesService
